/**
 * External dependencies
 */

import { get } from 'lodash';


/**
 * Internal dependencies
 */
import getCurrentUserId from './get-current-user-id';
import { getUser } from 'state/users/selectors';


export default (state) => {
    const userId = getCurrentUserId(state);

    if (!userId) {
        return null;
    }

    return getUser(state, userId);
};
